import { render, staticRenderFns } from "./StockAdjustmentDetailUpload.vue?vue&type=template&id=20bfa422&"
import script from "./StockAdjustmentDetailUpload.vue?vue&type=script&lang=js&"
export * from "./StockAdjustmentDetailUpload.vue?vue&type=script&lang=js&"
import style0 from "./StockAdjustmentDetailUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports